<template>
  <div class="cleanings-planning-list">

    <!-- PERIOD CARD -->
    <b-card class="period-card mb-3" no-body>
      <div class="p-3">
        <!-- Navigation row -->
        <div class="d-flex align-items-center mb-75">
          <b-button variant="primary" size="sm" class="btn-icon" @click="$emit('previous-period')">
            <feather-icon icon="ChevronLeftIcon" size="16" />
          </b-button>
          <span class="flex-grow-1 text-center font-weight-bold px-50 period-title period-title--clickable"
            @click="$emit('set-today')">{{ weekText }}</span>
          <b-button variant="primary" size="sm" class="btn-icon" @click="$emit('next-period')">
            <feather-icon icon="ChevronRightIcon" size="16" />
          </b-button>
        </div>
        <!-- Selector -->
        <v-select :value="selectedDaysNumber" :options="selectedDaysOptions" :reduce="(option) => option.value"
          :clearable="false" class="days-selector" @input="$emit('update:selectedDaysNumber', $event)" />
      </div>
    </b-card>

    <!-- LOADING -->
    <div v-if="loading" class="text-center text-primary my-2">
      <b-spinner class="align-middle mr-2" />
      <strong>{{ $t("Carregant") }}...</strong>
    </div>

    <!-- EMPTY -->
    <b-card v-else-if="!bookings || !bookings.length" class="text-center py-2">
      <p class="font-weight-bold mb-25">{{ $t('errors.emptyTable.title') }}</p>
      <p class="text-muted small mb-0">{{ $t('No hi ha serveis de neteja per al període seleccionat') }}</p>
    </b-card>

    <!-- SERVICE CARDS -->
    <cleanings-planning-list-item v-else v-for="booking in bookings" :key="booking.uuid" :booking="booking"
      class="mb-3" @toggle-cleaning="$emit('toggle-cleaning', $event)" />

  </div>
</template>

<script>
import {
  BCard, BButton, BSpinner,
} from "bootstrap-vue";
import FeatherIcon from "@core/components/feather-icon/FeatherIcon.vue";
import vSelect from "vue-select";
import CleaningsPlanningListItem from "@/views/cleaning/components/CleaningsPlanningListItem.vue";

export default {
  components: {
    BCard, BButton, BSpinner, FeatherIcon, vSelect, CleaningsPlanningListItem,
  },
  props: {
    bookings: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: () => false,
    },
    weekText: {
      type: String,
      default: () => "",
    },
    selectedDaysNumber: {
      type: Number,
      required: true,
    },
    selectedDaysOptions: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.cleanings-planning-list {
  .days-selector {
    min-width: 130px;
  }

  .period-card {
    .period-title {
      font-weight: bold;
      font-size: 1rem;
      line-height: 1.3;

      &--clickable {
        cursor: pointer;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }

  .service-card {
    border-left: 3px solid $primary;
  }
}
</style>
